import { ApiStory } from "data/api/ApiStory";
import { useEffect } from "react";
import { trackEvent } from 'services/frontend/Segment'

export function useRecordArticleViewed(story: ApiStory, paywalled: boolean, shareLinkCreatorEmail: string) {

    let tags = ``
    story?.categories?.forEach((category, index) => {
        tags = `${tags}${index > 0 ? ', ' : ''}${category.name}`
    })

    useEffect(() => {
        trackEvent("Article Viewed", {
          url: global?.window?.location?.href ?? "",
          tags,
          author: story?.author?.fullName ?? "",
          category: tags,
          article_title: story?.title ?? "",
          article_id: story?.id ?? "",
          paywall_shown: paywalled,
          referral: Boolean(shareLinkCreatorEmail), 
          referrer_email: shareLinkCreatorEmail ?? ""
        });  
    }, [])  
}